import {
  DeserializedRecord,
  deserializeItem,
  Deserializer,
  deserializeSingleRelationship,
  JSONAPIRecord,
  JSONAPISingleRelationship
} from "../../Helpers";
import {Component, deserializeProgramComponent} from "../Component";
import {Program} from "../../Program";

type NewComponentAssignment = Pick<Assignment, 'programComponent'>;

interface Assignment extends DeserializedRecord {
  program: Program
  programComponent: Component
}

interface AssignmentData extends JSONAPIRecord {
  relationships: {
    program: JSONAPISingleRelationship
    program_component: JSONAPISingleRelationship
  }
}

const deserializeComponentAssignment: Deserializer<Assignment, AssignmentData> = (data, included) => {
  const programComponent = deserializeSingleRelationship<Component>(data.relationships.program_component, included, deserializeProgramComponent);

  return {
    programComponent,
    ...deserializeItem(data)
  };
};

export {
  Assignment, deserializeComponentAssignment, NewComponentAssignment
};
